// @flow
import {
    DeviceInfoPanelHeading,
    DeviceInfoPanelListItem,
    DeviceInfoPanelValue,
    DeviceInfoPanelValueInput
} from './styles';
import type { FormFields, Translation } from './types';

import { FormattedMessage } from 'react-intl';
import { getDOMOnlyProps } from '~/core/utils/form/form-helpers';
import messages from '../intl';
import * as React from 'react';

type Props = {
    deviceName: string,
    fields: FormFields,
    headingIntl: Translation
};

const EditDeviceName = ({ headingIntl, deviceName, fields: { name } }: Props) => (
    <DeviceInfoPanelListItem>
        <DeviceInfoPanelHeading>
            <FormattedMessage {...headingIntl} />:
        </DeviceInfoPanelHeading>
        <DeviceInfoPanelValue>
            <DeviceInfoPanelValueInput
                maxLength={20}
                minLength={1}
                placeholder={deviceName}
                type="text"
                {...getDOMOnlyProps(name)}
            />
            {name.touched &&
                name.error && (
                    <div className="forms__validation forms__validation--show">
                        <FormattedMessage {...messages[name.error]} />
                    </div>
                )}
        </DeviceInfoPanelValue>
    </DeviceInfoPanelListItem>
);

export default EditDeviceName;



// WEBPACK FOOTER //
// ./src/components/widgets/device-info-panel/panel-list/edit-device-name.js